// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__xXSTT","ButtonFocus":"Button_ButtonFocus__VkGIa","ButtonInline":"Button_ButtonInline__RvV5q","ButtonTransparent":"Button_ButtonTransparent__MHZrm"};